/* unplugin-vue-components disabled */import { render } from "./PollQuizPlayer.vue?vue&type=template&id=7273a1ba&ts=true"
import script from "./PollQuizPlayer.vue?vue&type=script&lang=ts"
export * from "./PollQuizPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__